module.exports = __webpack_public_path__ + "point_breeze.2f62b2ee40da3f50937a28c7e4f7c6e1.png";